module.exports = __webpack_public_path__ + "img/report.fdea2e93.png";